import React from 'react';
import { useTranslation } from 'react-i18next';
import { IToggleModalProps } from '@app/dashboard/types/innerLayout/payment_integrations/toggle-props';
import { Modal, StatusIndicator } from '@unified-checkout/design-system';
import { Check, Xmark } from '@unified-checkout/design-system/icons/index';
import { IButton } from 'libs/design-system/src/types/Button/button';

export const ToggleModal = ({
    isOpen,
    flagIsPending,
    setShowToggle,
    flagIsSuccess,
    flagError,
    handleToggleChange,
    toggleState,
    flagReset
}: IToggleModalProps
) => {
    const { t } = useTranslation();
    const isProcessDone = flagIsSuccess || flagError;
    const isEnable = toggleState === true;

    const modalTitle = isProcessDone
        ?
        ''
        :
        isEnable
            ?
            t('innerLayout.paymentIntegrationsPage.table.headers.modal.titleDisableAutoCallback')
            :
            t('innerLayout.paymentIntegrationsPage.table.headers.modal.titleEnableAutoCallback')

    const modalDescription = isProcessDone
        ?
        undefined
        :
        isEnable
            ?
            t('innerLayout.paymentIntegrationsPage.table.headers.modal.descriptionDisableAutoCallback')
            :
            t('innerLayout.paymentIntegrationsPage.table.headers.modal.descriptionEnableAutoCallback')

    const status =
        flagIsSuccess
            ?
            <StatusIndicator
                status="success"
                icon={Check}
                hintText={toggleState
                    ?
                    t('innerLayout.paymentIntegrationsPage.table.headers.modal.successEnableAutoCallBack')
                    :
                    t('innerLayout.paymentIntegrationsPage.table.headers.modal.successDisableAutoCallBack')}
            />
            :
            flagError
                ?
                <StatusIndicator
                    status="error"
                    icon={Xmark}
                    hintText={t('innerLayout.errors.smthWentWrong')}
                />
                :
                null
    const btn =
        isProcessDone
            ?
            undefined
            :
            [
                !isEnable
                    ?
                    {
                        color: 'primary',
                        text: t('innerLayout.paymentIntegrationsPage.table.headers.modal.enable'),
                        onClickHandler: () => handleToggleChange(true),
                        loading: flagIsPending,
                    } as IButton
                    :
                    {
                        color: 'danger',
                        text: t('innerLayout.paymentIntegrationsPage.table.headers.modal.disable'),
                        onClickHandler: () => handleToggleChange(false),
                        loading: flagIsPending,
                    } as IButton
                ,
                {
                    color: 'secondary',
                    text: t('innerLayout.paymentIntegrationsPage.table.headers.modal.cancel'),
                    variant: 'outlined',
                    onClickHandler: () => {
                        setShowToggle(false);
                        flagReset();
                    },
                    disabled: flagIsPending,
                } as IButton,
            ]

    const modalProps: any = {
        state: "default",
        open: isOpen,
        hasCloseIcon: true,
        closeOnClickOutside: !flagIsPending,
        onCloseHandler: () => {
            setShowToggle(false);
            flagReset();
        },
        title: modalTitle,
        supportingText: modalDescription,
        btnsProps: btn,
    };

    return (
        <div>
            <Modal {...modalProps}>
                {status}
            </Modal>
        </div>
    );
}

